// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c0c18b9","455":"f1251180","977":"4c135bc8"}[chunkId] + ".chunk.js";
};